import { ActionRegistryCategory } from '../../ActionRegistryCategory';
import { ActionsLearnwareAspect } from './basic/ActionsLearnwareAspect';
export class ActionsLearnware extends ActionRegistryCategory {
    label = 'Learnware';
    constructor(parent) {
        super(parent);
    }
    c_a = new ActionsLearnwareAspect(this);
}
